import React from 'react';
import { Link } from 'react-router-dom';
import {
  Plus,
  Inbox,
  DollarSign,
  ClipboardList,
  Ticket,
} from 'lucide-react';

export default function QuickActions({ pendingRequestCount = 0, scrollable = false }) {
  return (
    <div
      className={
        scrollable
          ? 'flex flex-nowrap gap-2 overflow-x-auto pb-1 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden'
          : 'flex flex-wrap gap-2 overflow-x-auto pb-1'
      }
      aria-label="Quick actions"
    >
      <Link to="/dashboard/book-now" className="ga-btn-primary inline-flex shrink-0 items-center gap-2">
        <Plus className="h-4 w-4" /> New booking
      </Link>
      <Link to="/dashboard/booking-requests" className="relative ga-btn-ghost inline-flex shrink-0 items-center gap-2">
        <Inbox className="h-4 w-4" /> {scrollable ? 'Requests' : 'Booking requests'}
        {pendingRequestCount > 0 && (
          <span className="min-w-[20px] h-5 flex items-center justify-center rounded-full bg-red-500 text-white text-[11px] font-bold px-1.5">
            {pendingRequestCount}
          </span>
        )}
      </Link>
      <Link to="/dashboard/payments" className="ga-btn-ghost inline-flex shrink-0 items-center gap-2">
        <DollarSign className="h-4 w-4" /> Record payment
      </Link>
      <Link to="/dashboard/operations/daily" className="ga-btn-ghost inline-flex shrink-0 items-center gap-2">
        <ClipboardList className="h-4 w-4" /> Log operation
      </Link>
      <Link to="/dashboard/create-ticket" className="ga-btn-ghost inline-flex shrink-0 items-center gap-2">
        <Ticket className="h-4 w-4" /> Create ticket
      </Link>
    </div>
  );
}
